<template>
  <div class="dashboard-page">
    <h2 class="headline mb-5 text--primary">
      <span>Dashboard</span>
      <v-btn text icon color="accent"
        small class="ml-2"
        @click.prevent="onRefresh">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </h2>
    <v-card elevation="1" min-height="350" class="mb-3" :loading="loading">
      <template v-if="hasStats && chartData && totalProjects">
        <v-card-title class="subtitle-2 px-6 pt-6">Project Categories</v-card-title>
        <v-card-text class="px-6 py-6">
          <ms-pie-chart
            :chartData="chartData"
            :options="chartOptions"
            :styles="chartStyles"></ms-pie-chart>
        </v-card-text>
      </template>
      <template v-else>
        <v-card-text class="pa-6">
          <h4 class="black--text title">Nothing to display!</h4>
          <p>This board will be ready once your start adding projects.</p>
          <v-btn color="primary" depressed
            :to="addProject.to">Add Project</v-btn>
        </v-card-text>
      </template>
    </v-card>
    <v-row>
      <v-col cols="12" md="4" class="mb-3"
        v-for="item in firstRowItems" :key="item.id">
        <v-card elevation="1" height="200" class="d-flex align-end"
          :color="item.color"
          :dark="item.dark"
          :loading="loading">
          <v-card-text class="px-6 py-5" :class="item.textColor">
            <v-icon large :class="item.iconColor">{{ item.icon }}</v-icon>
            <h4 class="body-2 mb-2">{{ item.title }}</h4>
            <div class="display-3">{{ stats[item.id] || 0 | number('0a') }}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { mapActions, mapState } from 'vuex';
import types from '@/store/types';
import PieChart from '@/components/charts/PieChart.vue';

export default {
  name: 'dashboard-page',
  components: {
    'ms-pie-chart': PieChart,
  },
  data() {
    return {
      stats: {},
      hasStats: false,
      firstRowItems: [{
        id: 'total_projects_recorded',
        title: 'Projects Created',
        icon: 'mdi-file-document-box-check-outline',
        color: 'accent',
        dark: true,
      }, {
        id: 'total_milestones_recorded',
        title: 'Tasks Recorded',
        icon: 'mdi-flag-checkered',
        iconColor: 'accent--text',
        textColor: 'text--primary',
        dark: false,
      }, {
        id: 'total_expenses_recorded',
        title: 'Expense List Created',
        icon: 'mdi-cash-register',
        iconColor: 'accent--text',
        textColor: 'text--primary',
        dark: false,
      }],
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        legend: {
          display: true,
          position: 'left',
        },
        scales: {
          // xAxes: [{
          //   gridLines: {
          //     offsetGridLines: false,
          //   },
          //   ticks: {
          //     beginAtZero: true,
          //   },
          // }],
          // yAxes: [{
          //   ticks: {
          //     beginAtZero: true,
          //   },
          // }],
          plugins: {
            labels: {
              render: 'label',
              fontFamily: '"Roboto", sans-serif',
              showActualPercentages: false,
              fontColor: '#fff',
              position: 'outside',
            },
          },
        },
      },
    };
  },
  computed: {
    ...mapState('routes', {
      addProject: state => state.NEW_PROJECT,
    }),
    chartStyles() {
      return {
        position: 'relative',
        margin: '0 auto',
      };
    },
    projectStats() {
      const { project_category_counts } = this.stats;
      return project_category_counts || {};
    },
    totalProjects() {
      return Object.values(this.projectStats).reduce((total, num) => total + num, 0);
    },
  },
  methods: {
    ...mapActions('db', {
      fetchResults: types.GET_DASHBOARD_STATS,
    }),
    fillData() {
      const labels = Object.keys(this.projectStats);
      const data = Object.values(this.projectStats);
      this.chartData = {
        labels,
        datasets: [
          {
            label: '',
            backgroundColor: [
              'rgb(237, 187, 153)',
              'rgb(115, 198, 182)',
              'rgb(217, 136, 128)',
              'rgb(93, 173, 226)',
              'rgb(247, 220, 111)',
              'rgb(171, 235, 198)',
              'rgb(207, 216, 220)',
              'rgb(188, 170, 164)',
              'rgb(244, 143, 177)',
              'rgb(159, 168, 218)',
              'rgb(79, 195, 247)',
              'rgb(165, 214, 167)',
            ],
            barPercentage: 0.2,
            barThickness: 20,
            minBarLength: 2,
            data,
          },
        ],
      };
    },
    loadResults() {
      this.loading = true;
      this.fetchResults()
        .then((stats) => {
          this.hasStats = !!stats;
          this.stats = stats || {};
          this.fillData();
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
    },
    init() {
      this.loadResults();
    },
    onRefresh() {
      this.init();
    },
  },
  created() {
    this.init();
  },
};
</script>
